module.exports = __webpack_public_path__ + "static/media/save-money.37270f15.svg";